var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.46875 0.8125H1.52344C1.79688 0.8125 1.99219 1.04688 1.99219 1.32031L1.91406 5.14844C3.63281 2.53125 6.64062 0.8125 10 0.851562C15.3516 0.851562 19.6875 5.22656 19.6875 10.5391C19.6484 15.8906 15.3125 20.1875 10 20.1875C7.5 20.1875 5.19531 19.25 3.47656 17.7266C3.28125 17.5312 3.28125 17.2188 3.47656 17.0234L4.25781 16.2422C4.41406 16.0859 4.6875 16.0859 4.88281 16.2422C6.25 17.4531 8.00781 18.1562 10 18.1562C14.2188 18.1562 17.6562 14.7578 17.6562 10.5C17.6562 6.28125 14.2188 2.84375 10 2.84375C6.875 2.84375 4.21875 4.71875 3.00781 7.375L7.92969 7.25781C8.20312 7.25781 8.4375 7.45312 8.4375 7.72656V8.78125C8.4375 9.05469 8.20312 9.25 7.96875 9.25H0.46875C0.195312 9.25 0 9.05469 0 8.78125V1.28125C0 1.04688 0.195312 0.8125 0.46875 0.8125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelArrow);
export default __webpack_public_path__ + "static/media/cancel-arrow.8a069bf7e9cbf53503014728baf24acf.svg";
export { ForwardRef as ReactComponent };